"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkManagerBuilder = void 0;
const SdkManager_1 = require("./SdkManager");
class SdkManagerBuilder {
    static create() {
        return new SdkManagerBuilder();
    }
    addResiliencyConfiguration(resiliencyConfiguration) {
        this.resiliencyConfiguration = resiliencyConfiguration;
        return this;
    }
    addAuthClient(authClient) {
        this.authClient = authClient;
        return this;
    }
    addApsConfiguration(apsConfiguration) {
        this.apsConfiguration = apsConfiguration;
        return this;
    }
    addLogger(logger) {
        this.logger = logger;
        return this;
    }
    build() {
        return SdkManager_1.SdkManager.getInstance(this.apsConfiguration, this.resiliencyConfiguration, this.authClient, this.logger);
    }
}
exports.SdkManagerBuilder = SdkManagerBuilder;
